// This file was auto-generated by Fern from our API Definition.
/** The product family behind a hosted subscription connection. */
export const SubscriptionProviderKind = {
    Chatgpt: "chatgpt",
    Claude: "claude",
};
